import React from 'react'
import Card from '@material-ui/core/Card'
import CardMedia from '@material-ui/core/CardMedia'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import { useHistory } from 'react-router-dom'
import withAppconfig from '../../AppContext'
import { Box, Grid, Paper, Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import { useCookies } from 'react-cookie'
import { setReturnPathCookie } from '../../utils/returnpath'
import { getPosterUrl } from '../ViewUtils'
import moment from 'moment'
import 'moment/locale/fi' // Import Finnish locale for moment.js

const EventTicketCard = ({
  product,
  personname,
  appconfig,
  collection,
  isAuthRequired,
  isAuth,
}) => {
  const history = useHistory()
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(['gobackurl'])
  const { poster, id, variations, description, showOptionsOnFirstPage } = product
//  const path = [appconfig.pathPrefix, 'shop', 'ticket', id].join('/')
  const path = [appconfig.pathPrefix, 'shop', 'w', id].join('/')

  let price = ''
  if (variations && variations.length > 0) {
    price = (variations[0].price / 100).toFixed(2).replace('.', ',') + ' €'
  }

  const goToProduct = () => {
    console.log('goToProduct', { isAuthRequired, isAuth })
    if (isAuthRequired && !isAuth) {
      setReturnPathCookie(setCookie, path)
      history.push({ pathname: appconfig.pathPrefix + '/login', state: { from: path } })
      return
    } else {
      console.log('goToProduct', path)
      history.push(path)
    }
  }

  const posterUrl = getPosterUrl(poster, 1080)
  const descHeight = showOptionsOnFirstPage ? 200 : 500

    return (
      <Paper elevation={5} style={{ marginTop: 20, padding: 0 }}>
        <Grid container>
          <Grid item xs={12} sm={4}>
            {posterUrl && (
              <img
                src={posterUrl}
                alt=''
                style={{
                  width: '100%',
                  maxHeight: 200,
                  objectFit: 'cover',
                  marginTop: 0,
                  marginLeft: 0,
                  borderTopLeftRadius: '4px',
                }}
              />
            )}
          </Grid>
          <Grid item sm={6} xs={9}>
            <Box
              style={{ paddingLeft: 10, paddingRight: 10, textAlign: 'left', maxHeight: descHeight, overflowY: 'hidden' }}
            >
              <Typography variant='h6'>
                {product.name}
              </Typography>
              <Typography variant='body1'>
                {moment(product.start).format('D.M.YY H:mm')}
              </Typography>

              <Typography variant='subtitle1' style={{ paddingTop: 10 }}>
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </Typography>
            </Box>
          </Grid>
          <Grid item sm={2} xs={3}>
            <Box
              style={{ padding: 10, textAlign: 'right' }}
            >
              <Button
                size='small'
                variant='contained'
                color='primary'
                disabled={isAuthRequired && !isAuth}
                onClick={goToProduct}
              >
                Osta liput
              </Button>
            </Box>
          </Grid>
          {showOptionsOnFirstPage && (
            <Grid
              item
              xs={12}
              style={{
                padding: 10,
              borderTop: '1px solid #ccc',
              marginTop: 0,
            }}
          >
            <Typography variant='h6'>Lippuvaihtoehdot</Typography>
            {variations && variations.length > 0 ? (
              variations.map((v) => {
                const available = v.ticketsavailable || 0
                const sold = v.quantity || 0
                let availableText = ''
                if (available > 0) {
                  const soldPercentage = Math.round((sold / available) * 100)
                  // if soldPercentage is 100, we show "Loppuunmyyty"
                  // if soldPercentage is 0, we show "Saatavilla"
                  // if soldPercentage is above 75 we show "Vain muutama jäljellä"
                  if (soldPercentage === 100) {
                    availableText = 'Loppuunmyyty'
                  } else if (soldPercentage >= 0 && soldPercentage <= 75) {
                    availableText = 'Saatavilla'
                  } else if (soldPercentage > 75) {
                    availableText = 'Vain muutama jäljellä'
                  }
                }
                return (
                  <Box
                    key={v.id}
                    style={{ padding: 5, borderBottom: '1px solid #ccc' }}
                    display='flex'
                    justifyContent='space-between'
                    alignItems='center'
                  >
                    <Typography key={v.id + '-n'} variant='subtitle1'>
                      {v.name}
                    </Typography>
                    <Typography key={v.id + '-p'} variant='subtitle1'>
                      {availableText} {(v.price / 100).toFixed(2).replace('.',',')} €
                    </Typography>
                  </Box>
                )
              })
            ) : (
              <Typography variant='subtitle1'>{price}</Typography>
            )}
            </Grid>
          )}
        </Grid>
      </Paper>
    )
}

export default withAppconfig(EventTicketCard)
